<template>
  <div
    class="mars-ape-sider"
    :class="{ 'mars-ape-sider-collapse': isCollapse }"
  >
    <div
      :class="[
        'sider-logo',
        this.$config.domain.domain == 'opr-yfx.51xinlong.com'
          ? 'sider-logo-yfx'
          : '',
      ]"
      :style="
        (this.$config.domain.ename == 'oprzezhehui' || this.$config.domain.ename == 'hualingyun') ? 'padding-left:0px' : ''
      "
    >
      <a
        class="zzhClass"
        href="/"
        v-if="this.$config.domain.ename == 'oprzezhehui' || this.$config.domain.ename == 'hualingyun'"
      >
        <img style="width: 120px" :src="this.mxDomain.siderLogo" alt="" />
      </a>
      <a href="/" v-else>
        <img
          :class="
            this.$config.domain.domain === 'opr-yfx.51xinlong.com'
              ? 'img img-big'
              : 'img'
          "
          :src="
            this.mxDomain.title == '管理中台' ? '' : this.mxDomain.siderLogo
          "
          alt=""
        />
        <h1>
          {{
            this.mxDomain.title == "管理中台" ||
            this.$config.domain.domain === "opr-yfx.51xinlong.com"
              ? ""
              : this.mxDomain.title
          }}
        </h1>
      </a>
    </div>
    <el-menu
      v-if="isContract == 1"
      class="sider-menu"
      :default-active="routePath"
      :unique-opened="true"
      active-text-color="#FFFFFF"
      :collapse="isCollapse"
    >
      <li role="menuitem" aria-haspopup="true" class="el-submenu">
        <router-link to="/">
          <div class="el-submenu__title" style="padding-left: 20px">
            <i
              class="iconfont iconyemian iconbtn"
              :class="[isCollapse ? 'is-collapse' : '']"
              style="color: #fff"
            ></i
            ><span v-if="!isCollapse">首页</span>
          </div>
        </router-link>
      </li>
      <el-submenu
        v-for="(v, k) in userMenuList"
        :key="k"
        :index="v['id'].toString()"
      >
        <template slot="title">
          <i
            class="iconfont"
            style="color: #fff"
            :class="[v['icon'], isCollapse ? 'is-collapse' : '']"
          ></i>
          <span>{{ v["display_name"] }}</span>
        </template>
        <div class="sider-menu-sub">
          <el-menu-item
            v-for="(v, k) in v['children']"
            :key="k"
            :index="v['url']"
          >
            <router-link :to="v['url']">{{ v["display_name"] }}</router-link>
          </el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      userMenuList: [],
      // 在后台此字段后便可删除，此处为返回数据简洁版
      rebatelist: {
        id: "208170340667473921",
        url: "/channelrebate",
        display_name: "渠道返佣",
        icon: "",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      isContract: (state) => state.isContract,
    }),
    ...mapGetters(["isCollapse", "menuList", "routePath"]),
  },
  methods: {
    ...mapMutations([
      "handleMenuList",
      "handleRoutePath",
      "handleUserPermissions",
    ]),
  },
  async created() {
    //  userMenuList = await this.$api.getUserMenuList();//用户菜单列表
    var menulist = await this.$api.getUserMenuList(); //用户菜单列表
    menulist.forEach((item) => {
      item.children.forEach((item1, index1) => {
        if (
          item1.url == "/businessapproval" &&
          this.$config.domain.ename !== "opryousuiyun"
        ) {
          item.children.splice(index1, 1);
        }
      });
    });
    this.userMenuList = menulist;
    // console.log(userMenuList[0].children.push(this.rebatelist),"渠道返佣页面")
    // menuList[1]
    // 若有不对换为注释内容
    // this.userMenuList[0].children.push(this.rebatelist)
    // console.log(menuList[1],"渠道返佣")
    let userPermissionsList = await this.$api.getUserPermissionsList();
    // this.handleMenuList(userMenuList)
    this.handleUserPermissions(userPermissionsList);
    if (Object.keys(this.$route.params).length != 0 && this.$route.matched[1]) {
      this.handleRoutePath(this.$route.matched[1].path);
    } else {
      this.handleRoutePath(this.$route.path);
    }
  },
};
</script>

<style lang="stylus">
.zzhClass {
  padding-top: 5px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.el-submenu__title {
  font-size: 10pt !important;
  padding-left: 24px !important;
  padding-right: 34px;
  width: 100%;
  line-height: 50px;
  height: 50px;
}

.mars-ape-sider:not(.mars-ape-sider-collapse) {
  width: 180px !important;
  transition: all 0.3s;
}

.mars-ape-sider-collapse, .el-menu--collapse {
  width: 80px !important;
  transition: all 0.3s;
}

.sider-logo-yfx {
  padding-left: 0px !important;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mars-ape-sider {
  /* 导航头部 */
  .sider-logo {
    height: 64px;
    position: relative;
    line-height: 64px;
    padding-left: 24px;
    transition: all 0.3s;
    overflow: hidden;

    img {
      display: inline-block;
      vertical-align: middle;
      width: 32px;
    }

    .img-big {
      display: inline-block;
      vertical-align: middle;
      width: 80px;
      height: auto !important;
    }

    h1 {
      color: #fff;
      display: inline-block;
      vertical-align: middle;
      font-size: 18px;
      margin: 0 0 0 12px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      font-weight: 600;
    }
  }

  /* 导航内容 */
  .sider-menu {
    min-height: 100vh;
    width: auto !important;
    transition: all 0.3s;
    // font: 12px;
  }

  .el-menu {
    border-right: solid 0px !important;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #2c343f;
  }

  .el-submenu a {
    text-decoration: none;
  }

  .el-submenu__title, .el-submenu__title {
    color: #FFFFFF;
  }

  .el-submenu .el-menu-item {
    height: 40px;
    line-height: 38px;
    min-width: 180px !important;
  }

  .el-menu-item {
    height: 40px;
    font-size: 12px;
    line-height: 40px;
    padding-left: 48px !important;
    padding-right: 16px;
    color: #b8bec3;

    a {
      color: #FFFFFF;
      text-decoration: none;
      display: block;
    }
  }

  .el-submenu [class^='iconfont'].is-collapse {
    padding-left: 8px;
    font-size: 16px;
  }

  .el-submenu [class^='iconfont']:not(.is-collapse) {
    vertical-align: middle;
    margin-right: 10px;
    display: inline-block;
    min-width: 14px;
    text-align: center;
  }

  .el-menu-item:focus {
    background-color: #2C343F;
  }

  .el-menu-item:hover {
    background-color: #232A32;
  }

  .el-menu-item:hover a, .el-menu-item:focus a {
    color: #ffffff;
  }

  .el-submenu__title:hover, .el-submenu__title:focus {
    background-color: #232A32;
  }

  .el-submenu.is-opened .el-submenu__title, .el-submenu.is-opened .el-submenu__title>i, .el-submenu.is-active .el-submenu__title, .is-active>a, .el-submenu.is-active .el-submenu__title>i {
    color: #ffffff;
  }

  .el-menu-item.is-active>a {
    color: #FFD04B;
  }

  /* 折叠后子菜单效果 */
  .el-menu--vertical {
    left: 84px !important;
  }

  .el-menu--popup {
    border-radius: 4px;
    min-width: 160px;
  }
}
</style>